namespace $.$$ {
	export class $shm_hitalama_map_widget_float_chrome_telegram extends $.$shm_hitalama_map_widget_float_chrome_telegram {
		
		@ $mol_mem
		rpc_listener() {
			const rpc = new $mol_rpc_server()
			const handlers = {
				id: ( id: string, title = '' )=> {
					this.chat_title( title )
					this.chat_id( id )
				}
			}
			rpc.handlers = ()=> handlers
			return rpc.listener()
		}

		@ $mol_mem_key
		Content_by_type( name: string ): Record< ReturnType< $shm_hitalama_map_widget_float_form_custom['field_type'] >, any > {
			return this.Content_by_type_override( name )
		}

		@ $mol_mem
		require_id() {
			if( window.parent === window ) return null
			window.parent.postMessage( { name: 'id' }, '*' )
			return null
		}

		@ $mol_mem
		chat_id( next?: string ) {
			return next ?? ''
		}

		field_names() {
			return [ this.chat_id() ]
		}

		field_type( id: string ) {
			return 'any'
		}
		
	}
}
